<div class="sidebar-sticky">

  <!-- ── VIEW MODE ───────────────────────────── -->
  @if (mode === 'view') {

    @if (role) {
      <div class="sidebar-card">
        <h6 class="sidebar-card__label">CURRENT ROLE</h6>
        <div class="role-preview">
          <div class="role-preview__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M5.338.56C6.408.26 7.3 0 8 0s1.592.26 2.662.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.791-2.483 10.007A11.7 11.7 0 0 1 9.593 15.152a7 7 0 0 1-1.094.638c-.3.13-.593.21-.844.21s-.543-.08-.844-.21a7 7 0 0 1-1.094-.638A11.7 11.7 0 0 1 3.2 12.699C1.507 10.483.124 7.169.72 2.692A1.54 1.54 0 0 1 1.764 1.43c.658-.215 1.777-.57 2.887-.87z"/>
            </svg>
          </div>
          <div class="role-preview__info">
            <div class="role-preview__name">{{ role.name }}</div>
            <div class="role-preview__code">{{ displayCode }}</div>
          </div>
          <span class="status-chip" [class.status-chip--active]="role.active" [class.status-chip--inactive]="!role.active">
            {{ role.active ? 'Active' : 'Inactive' }}
          </span>
        </div>
        <div class="role-meta-grid">
          <div class="role-meta-item">
            <span class="role-meta-item__label">Linked users</span>
            <span class="role-meta-item__value">{{ role.usersCount }}</span>
          </div>
          <div class="role-meta-item">
            <span class="role-meta-item__label">Permissions</span>
            <span class="role-meta-item__value">{{ role.permissionsCount }}</span>
          </div>
          <div class="role-meta-item">
            <span class="role-meta-item__label">Last edited</span>
            <span class="role-meta-item__value">{{ role.lastEditedAt | date:'d MMM yyyy' }}</span>
          </div>
          @if (role.lastEditedBy) {
            <div class="role-meta-item">
              <span class="role-meta-item__label">By</span>
              <span class="role-meta-item__value">{{ role.lastEditedBy }}</span>
            </div>
          }
        </div>
      </div>
    }

    <div class="sidebar-card">
      <div class="sidebar-card__header-row">
        <h6 class="sidebar-card__label">ACCESS BY MODULE</h6>
        <span class="counter-badge">{{ role?.permissionsCount }}/{{ totalPermissions }}</span>
      </div>
      <div class="module-list">
        @for (modName of MODULE_NAMES; track modName) {
          <div class="module-list__row">
            <span class="module-list__name">{{ modName }}</span>
            @if (moduleCountsMap[modName]) {
              <span class="module-list__status">
                @if (moduleCountsMap[modName].granted === 0) { None } @else { {{ moduleCountsMap[modName].granted }}/{{ moduleCountsMap[modName].total }} }
              </span>
            }
          </div>
        }
      </div>
    </div>

    <div class="audit-box">
      <div class="audit-box__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
          <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
        </svg>
      </div>
      <p class="audit-box__text">
        <strong>Audit log active</strong>&ensp;All permission changes are recorded with timestamp and actor.
      </p>
    </div>

  }

  <!-- ── EDIT MODE — IDLE (no changes yet) ──── -->
  @if (mode === 'edit-idle') {

    <div class="sidebar-card">
      <h6 class="sidebar-card__label">PENDING CHANGES</h6>
      <div class="pending-empty">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
          <path d="M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
        </svg>
        <p>No changes yet. Toggle permissions to see the impact analysis here.</p>
      </div>
    </div>

    <div class="sidebar-card">
      <div class="sidebar-card__header-row">
        <h6 class="sidebar-card__label">ACCESS BY MODULE</h6>
        <span class="counter-badge">{{ role?.permissionsCount }}/{{ totalPermissions }}</span>
      </div>
      <div class="module-list">
        @for (modName of MODULE_NAMES; track modName) {
          <div class="module-list__row">
            <span class="module-list__name">{{ modName }}</span>
            @if (moduleCountsMap[modName]) {
              <span class="module-list__status">
                @if (moduleCountsMap[modName].granted === 0) { None } @else { {{ moduleCountsMap[modName].granted }}/{{ moduleCountsMap[modName].total }} }
              </span>
            }
          </div>
        }
      </div>
    </div>

  }

  <!-- ── EDIT MODE — WITH CHANGES ─────────── -->
  @if (mode === 'edit-changes') {

    <div class="sidebar-card impact-card">
      <h6 class="sidebar-card__label">IMPACT ANALYSIS</h6>
      <div class="impact-grid">
        <div class="impact-stat">
          <span class="impact-stat__num impact-stat__num--neutral">{{ impact.affectedUsers }}</span>
          <span class="impact-stat__label">Users affected</span>
        </div>
        @if (impact.gainAccess > 0) {
          <div class="impact-stat">
            <span class="impact-stat__num impact-stat__num--gain">+{{ impact.gainAccess }}</span>
            <span class="impact-stat__label">Gain access</span>
          </div>
        }
        @if (impact.loseAccess > 0) {
          <div class="impact-stat">
            <span class="impact-stat__num impact-stat__num--loss">-{{ impact.loseAccess }}</span>
            <span class="impact-stat__label">Lose access</span>
          </div>
        }
      </div>
    </div>

    @if (diff.added.length > 0) {
      <div class="sidebar-card">
        <h6 class="sidebar-card__label">PERMISSIONS ADDED</h6>
        <div class="diff-list">
          @for (code of diff.added; track code) {
            <div class="diff-item diff-item--added">
              <span class="diff-badge diff-badge--added">+ ADDED</span>
              <span class="diff-item__name">{{ formatPermCode(code) }}</span>
            </div>
          }
        </div>
      </div>
    }

    @if (diff.removed.length > 0) {
      <div class="sidebar-card">
        <h6 class="sidebar-card__label">PERMISSIONS REMOVED</h6>
        <div class="diff-list">
          @for (code of diff.removed; track code) {
            <div class="diff-item diff-item--removed">
              <span class="diff-badge diff-badge--removed">- REMOVED</span>
              <span class="diff-item__name">{{ formatPermCode(code) }}</span>
            </div>
          }
        </div>
      </div>

      <div class="sidebar-card">
        <div class="critical-warning">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
          </svg>
          <p>Removing permissions will immediately revoke access for all linked users.</p>
        </div>
      </div>
    }

  }

  <!-- ── SAVE SUCCESS ──────────────────────── -->
  @if (mode === 'save-success') {

    <div class="sidebar-card success-card">
      <div class="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
        </svg>
      </div>
      <h6 class="success-title">Changes saved</h6>
      <p class="success-sub">Role updated successfully.</p>
    </div>

    @if (auditEntries.length > 0) {
      <div class="sidebar-card">
        <h6 class="sidebar-card__label">AUDIT LOG</h6>
        <div class="audit-entries">
          @for (entry of auditEntries; track entry) {
            <div class="audit-entry">
              <span class="audit-entry__event">{{ entry.event }}</span>
              <span class="audit-entry__actor">{{ entry.actor }}</span>
              <span class="audit-entry__time">{{ entry.timestamp | date:'d MMM yyyy, HH:mm' }}</span>
              @if (entry.detail) {
                <span class="audit-entry__detail">{{ entry.detail }}</span>
              }
            </div>
          }
        </div>
      </div>
    }

  }

</div>
